const isBrowser = (): boolean => {
  return (
    typeof window !== "undefined" &&
    typeof window !== undefined &&
    window !== undefined
  );
};

export default isBrowser;
